import { forwardRef } from "react";

import { Box, StackProps, Stack, useTheme } from "@mui/material";

import { mergeSx } from "@/common/helpers/mergeSx";

export type StorybookMobileDialogDrawerPreviewProps = StackProps & {
  dialogMode: "default" | "overflow";
};

export const StorybookMobileDialogDrawerPreview = forwardRef<HTMLDivElement, StorybookMobileDialogDrawerPreviewProps>(
  ({ sx, children, dialogMode, ...rest }, ref) => {
    const theme = useTheme();

    return (
      <Box
        sx={{
          backgroundColor: theme.palette.overlay.neutral.moderate,
          paddingBlockStart: dialogMode === "default" ? { xs: 2, md: 4 } : 0,
        }}
      >
        <Stack
          ref={ref}
          {...rest}
          sx={mergeSx(
            {
              maxWidth: 444,
              maxHeight: 600,
              marginInline: "auto",
              backgroundColor: theme.palette.surface.neutral.white,
              borderRadius: dialogMode === "default" ? "20px 20px 0 0" : undefined,
              boxShadow: theme.shadows[8],
            },
            sx
          )}
        >
          {children}
        </Stack>
      </Box>
    );
  }
);

StorybookMobileDialogDrawerPreview.displayName = "StorybookMobileDialogDrawerPreview";
